/*requires context.js */
/*requires hei.js */
//
// Javascript tools for various ajax utility methods
//
//  Drew McMinn
//  May 2015
//
HEIJS.AjaxUtils = function () {
  this.userService = new RESTService({ baseUrl: HEIJS.context.convertToContextUri('https://svc.hendersonengineers.com'), routePrefix: 'User/API' });
};

HEIJS.AjaxUtils.prototype = {
  //
  //  Properties
  //
  userService: null,

  //
  //  Methods
  //
  GetUserProperty: function (key, applicationId, callback) {
    var self = this;
    if (!key || !applicationId) return;

    self.userService.Get('UserProperty', { key: key, applicationId: applicationId }).then(function(result) {
      if (callback) {
        callback(result);
      }
    });
  },

  SetUserProperty: function (key, value, applicationId, callback) {
    var self = this;
    if (!key || !applicationId) return;

    self.userService.Update('UserProperty', { key: key, value: value, applicationId: applicationId }).then(function() {
      if (callback) {
        callback();
      }
    });
  },

  InitiateHelpTour: function (steps, forceTour, callback) {
    var self = this;
    if (!steps || steps.length <= 0 || !HEIJS.context.applicationID) return;

    // fix for anno causing forms to submit/postback randomly
    for (var i = 0; i < steps.length; i++) { 
		(function(step, stepOnShow) {
			step.onShow = function(anno, $target, $annoElem) {
				$('.anno-btn').on('click', function (e) { e.preventDefault(); });
				
				if (typeof stepOnShow === 'function') {
					return stepOnShow(anno, $target, $annoElem);
				}
			};
		})(steps[i], steps[i].onShow);
	};

    var key = 'helptour_' + window.location.hostname + window.location.pathname;
    self.GetUserProperty(key, HEIJS.context.applicationID, function (d) {

      // no value was returned, meaning the user has not been through this help tour, initiate it
      if (forceTour || !d || d.UserPropertiesID <= 0) {
        self.SetUserProperty(key, true, HEIJS.context.applicationID);
        var a = new Anno(steps).show();
        if (callback) callback(a);
        $('.anno-btn').on('click', function (e) { e.preventDefault(); });
      }
    });
  }
};